module.exports = __webpack_public_path__ + "static/media/1031_Hero.25b8413a.jpg";